export default "__VITE_ASSET__BQ3163vD__"